import React, {useState} from 'react';
import {PageHeader, Row, Col} from 'antd';
import MomentForm from './Form';
import SendArea from '@/page/customer/MsgPage/Send/SendArea';
import MsgContext from '@/page/customer/MsgPage/msgContext';
import View from './View';
import styles from '../../index.module.less';
import {useEditAuthService} from '@/page/admin/adminService';

export default function SendMoment() {
    const editable = useEditAuthService(['global:customer_moment_send:w']);
    const [userIds, setUserIds] = useState([]);
    const [count, setCount] = useState(0);
    const [names, setNames] = useState('');
    const [sendType, setSendType] = useState(2);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [link, setLink] = useState(null);
    const [images, setImages] = useState([]);
    const [videos, setVideos] = useState([]);
    const [viewText, setViewText] = useState(null);

    function onSelect(subUserIds) {
        setUserIds(subUserIds);
    }

    return (
        <MsgContext.Provider
            value={{
                count,
                setCount,
                userIds,
                setUserIds,
                sendType,
                setSendType,
                setSelectedUsers,
                selectedUsers,
                names,
                setNames,
                link,
                setLink,
                images,
                setImages,
                videos,
                setVideos,
                viewText,
                setViewText,
            }}
        >
            <div style={{overflowY: 'auto'}}>
                <PageHeader title={'朋友圈群发'} />
                <Row className={styles.tableContainer}>
                    <Col span={12}>
                        <SendArea onSelect={onSelect} isMoment={true} editable={editable}/>
                        <MomentForm editable={editable}/>
                    </Col>
                    <Col span={8} offset={2}>
                        <View />
                    </Col>
                </Row>
            </div>
        </MsgContext.Provider>
    );
}
